<template>
    <hr class="my-[30px]">
    <h2>Il tuo archivio</h2>
    <div class="flex flex-col sm:flex-row justify-end mb-[40px]">
        <div class="w-full block sm:flex justify-center">
            <select class="select mb-[10px] sm:mb-0 mr-[10px]" v-model="mese">
                <option value="">Seleziona mese</option>
                <option v-for="(month, idM) in months" :key="idM" :value="month">{{ month }}</option>
            </select>            
            <select class="select mr-0 sm:mr-[10px]" v-model="anno">
                <option value="">Seleziona anno</option>
                <option v-for="(year, idY) in years" :key="idY" :value="year">{{ year }}</option>
            </select>
        </div>
        <button class="button py-[10px] px-[15px] mt-[10px] sm:mt-0" @click="filterSurveys">Filtra</button>
    </div>

    <div v-if="perizieAutoFiltered?.length > 0" :title="isAutoOpen ? 'Clicca per rimpicciolire' : 'Clicca per ingrandire'" class="accordion-cnt" 
        :class="!isAutoOpen ? 'mb-[30px]' : 'mb-0'" @click="isAutoOpen = !isAutoOpen" id="Auto">
        <h3 class="title"><font-awesome-icon icon="fa-solid fa-car-side" /> Auto</h3>
        <span class="icon-cnt">
            <span v-if="!isAutoOpen" class="accordion-icon rotate"></span><span class="accordion-icon"></span>
        </span>
    </div>
    <div v-if="isAutoOpen && perizieAutoFiltered?.length > 0" class="cnt-perizie">
        <div v-for="(auto, idxA) in perizieAutoFiltered" :key="idxA" class="cnt-perizia">
            <div class="perizia" :class="idxA > 0 ? 'mt-[10px]' : ''">
                <span class="text-[#f8f9fa] sm:w-[85%] font-bold m-0">{{ auto.marca }} {{ auto.veicolo }}<span v-if="auto?.data">, {{ auto.data }}</span></span>
                <div class="bg-[#e96932] sm:w-[14%] flex justify-end items-center rounded-[10px] sm:flex-wrap gap-[7px] mt-[5px] sm:mt-0 sm:ml-[10px] p-2"> 
                    <!--<font-awesome-icon :icon="['fas', 'pen-to-square']" alt="Aggiorna perizia" title="Aggiorna perizia" class="text-[#f8f9fa] text-xl cursor-pointer" @click="openEditPerizia(idxA, 'auto')" />-->
                    <font-awesome-icon :icon="['fas', 'envelope']" alt="Invia perizia tramite email" title="Invia perizia tramite email" class="text-[#f8f9fa] text-xl cursor-pointer" @click="openSendEmailPerizia(idxA, 'auto')" />
                    <font-awesome-icon :icon="['fas', 'trash']" alt="Elimina perizia" title="Elimina perizia" class="text-[#f8f9fa] text-xl cursor-pointer" @click="deletePerizia(idxA, auto, 'Auto')" />
                    <font-awesome-icon :icon="['fas', 'download']" alt="Download Eurotax blu" title="Download Eurotax Blu" class="text-[#1598ce] text-xl cursor-pointer" @click="downloadPdf(auto, 'auto', true)" />
                    <font-awesome-icon :icon="['fas', 'download']" alt="Download Eurotax blu" title="Download Eurotax Giallo" class="text-[#ffd21c] text-xl cursor-pointer" @click="downloadPdf(auto, 'auto', false)" />
                </div>
            </div>
            <!--<div v-if="isEditOpen?.auto[idxA]" class="my-[20px] px-[10px]">
                <input type="number" placeholder="Chilometri percorsi" v-model="km" class="mb-2" />
                <input type="number" placeholder="Valore attribuito dal concessionario (€)" v-model="importo" class="mb-2" />
                <div class="flex justify-end">
                    <button class="button py-[10px] px-[10px]" @click="updatePerizia(auto, 'auto')">
                        <span>Aggiorna</span>
                    </button>
                </div>
            </div>-->
            <div v-if="isEmailOpen?.auto[idxA]" class="flex items-center my-[20px] px-[10px]">
                <input type="text" placeholder="Email" v-model="email" />
                <button class="button ml-[5px] py-[10px] px-[10px]" @click="sendEmail(auto, 'auto')">
                    <span>Invia</span>
                </button>
            </div>   
        </div>

        <div class="flex justify-center items-center mt-[10px]">
            <button class="button py-[5px] px-[10px]" :class="{ 'disabled': autoPage < 2 }" :disabled="autoPage < 2" @click="firstPage('Auto')">
                <font-awesome-icon :icon="['fas', 'angles-left']" class="text-xl" />
            </button>
            <button class="button ml-[5px] py-[5px] px-[10px]" :class="{ 'disabled': autoPage < 2 }" :disabled="autoPage < 2" @click="prevPage('Auto')">
                <font-awesome-icon :icon="['fas', 'angle-left']" class="text-xl" />
            </button>
            <div class="mx-[20px] text-xl">{{ autoPage }}</div>
            <button class="button mr-[5px] py-[5px] px-[10px]" :class="{ 'disabled': autoPage >= autoPaging?.totPages }" 
            :disabled="autoPage >= autoPaging?.totPages" @click="nextPage('Auto')">
                <font-awesome-icon :icon="['fas', 'angle-right']" class="text-xl" />
            </button>
            <button class="button py-[5px] px-[10px]" :class="{ 'disabled': autoPage >= autoPaging?.totPages }" 
            :disabled="autoPage >= autoPaging?.totPages" @click="lastPage('Auto')">
                <font-awesome-icon :icon="['fas', 'angles-right']" class="text-xl" />
            </button>
        </div>      
    </div>

    <div v-if="perizieMotoFiltered?.length > 0" :title="isMotoOpen ? 'Clicca per rimpicciolire' : 'Clicca per ingrandire'" class="accordion-cnt" 
        :class="!isMotoOpen ? 'mb-[30px]' : 'mb-0'" @click="isMotoOpen = !isMotoOpen" id="Moto">
        <h3 class="title"><font-awesome-icon icon="fa-solid fa-motorcycle" /> Moto</h3>
        <span class="icon-cnt">
            <span v-if="!isMotoOpen" class="accordion-icon rotate"></span><span class="accordion-icon"></span>
        </span>
    </div>
    <div v-if="isMotoOpen && perizieMotoFiltered?.length > 0" class="cnt-perizie">
        <div v-for="(moto, idxM) in perizieMotoFiltered" :key="idxM" class="cnt-perizia">
            <div class="perizia" :class="idxM > 0 ? 'mt-[10px]' : ''">
                <span class="text-[#f8f9fa] sm:w-[85%] font-bold m-0">{{ moto.marca }} {{ moto.veicolo }}<span v-if="moto?.data">, {{ moto.data }}</span></span>
                <div class="bg-[#e96932] sm:w-[14%] flex justify-end items-center rounded-[10px] sm:flex-wrap gap-[7px] mt-[5px] sm:mt-0 sm:ml-[10px] p-2"> 
                    <!--<font-awesome-icon :icon="['fas', 'pen-to-square']" alt="Aggiorna perizia" title="Aggiorna perizia" class="text-[#f8f9fa] text-xl cursor-pointer" @click="openEditPerizia(idxM, 'moto')" />-->
                    <font-awesome-icon :icon="['fas', 'envelope']" alt="Invia perizia tramite email" title="Invia perizia tramite email" class="text-[#f8f9fa] text-xl cursor-pointer" @click="openSendEmailPerizia(idxM, 'moto')" />
                    <font-awesome-icon :icon="['fas', 'trash']" alt="Elimina perizia" title="Elimina perizia" class="text-[#f8f9fa] text-xl cursor-pointer" @click="deletePerizia(idxM, moto, 'Moto')" />
                    <font-awesome-icon :icon="['fas', 'download']" alt="Download Eurotax blu" title="Download Eurotax Blu" class="text-[#1598ce] text-xl cursor-pointer" @click="downloadPdf(moto, 'moto', true)" />
                    <font-awesome-icon :icon="['fas', 'download']" alt="Download Eurotax blu" title="Download Eurotax Giallo" class="text-[#ffd21c] text-xl cursor-pointer" @click="downloadPdf(moto, 'moto', false)" />
                </div>
            </div>
            <!--<div v-if="isEditOpen?.moto[idxM]" class="my-[20px] px-[10px]">
                <input type="number" placeholder="Chilometri percorsi" v-model="km" class="mb-2" />
                <input type="number" placeholder="Valore attribuito dal concessionario (€)" v-model="importo" class="mb-2" />
                <div class="flex justify-end">
                    <button class="button py-[10px] px-[10px]" @click="updatePerizia(moto, 'moto')">
                        <span>Aggiorna</span>
                    </button>
                </div>
            </div>-->
            <div v-if="isEmailOpen?.moto[idxM]" class="flex items-center my-[20px] px-[10px]">
                <input type="text" placeholder="Email" v-model="email" />
                <button class="button ml-[5px] py-[10px] px-[10px]" @click="sendEmail(moto, 'moto')">
                    <span>Invia</span>
                </button>
            </div>   
        </div>
        <div class="flex justify-center items-center mt-[10px]">
            <button class="button py-[5px] px-[10px]" :class="{ 'disabled': motoPage < 2 }" :disabled="motoPage < 2" @click="firstPage('Moto')">
                <font-awesome-icon :icon="['fas', 'angles-left']" class="text-xl" />
            </button>
            <button class="button ml-[5px] py-[5px] px-[10px]" :class="{ 'disabled': motoPage < 2 }" :disabled="motoPage < 2" @click="prevPage('Moto')">
                <font-awesome-icon :icon="['fas', 'angle-left']" class="text-xl" />
            </button>
            <div class="mx-[20px] text-xl">{{ motoPage }}</div>
            <button class="button mr-[5px] py-[5px] px-[10px]" :class="{ 'disabled': motoPage >= motoPaging?.totPages }" 
            :disabled="motoPage >= motoPaging?.totPages" @click="nextPage('Moto')">
                <font-awesome-icon :icon="['fas', 'angle-right']" class="text-xl" />
            </button>
            <button class="button py-[5px] px-[10px]" :class="{ 'disabled': motoPage >= motoPaging?.totPages }" 
            :disabled="motoPage >= motoPaging?.totPages" @click="lastPage('Moto')">
                <font-awesome-icon :icon="['fas', 'angles-right']" class="text-xl" />
            </button>
        </div>
    </div>

    <div v-if="perizieVcomFiltered?.length > 0" :title="isVcomOpen ? 'Clicca per rimpicciolire' : 'Clicca per ingrandire'" class="accordion-cnt" 
        :class="!isVcomOpen ? 'mb-[30px]' : 'mb-0'" @click="isVcomOpen = !isVcomOpen" id="Vcom">
        <h3 class="title"><font-awesome-icon icon="fa-solid fa-truck-moving" /> Veicoli commerciali</h3>
        <span class="icon-cnt">
            <span v-if="!isVcomOpen" class="accordion-icon rotate"></span><span class="accordion-icon"></span>
        </span>
    </div>
    <div v-if="isVcomOpen && perizieVcomFiltered?.length > 0" class="cnt-perizie">
        <div v-for="(ind, idxI) in perizieVcomFiltered" :key="idxI" class="cnt-perizia">
            <div class="perizia" :class="idxI > 0 ? 'mt-[10px]' : ''">
                <span class="text-[#f8f9fa] sm:w-[85%] font-bold m-0">{{ ind.marca }} {{ ind.veicolo }}<span v-if="ind?.data">, {{ ind.data }}</span></span>
                <div class="bg-[#e96932] sm:w-[14%] flex justify-end items-center rounded-[10px] sm:flex-wrap gap-[7px] mt-[5px] sm:mt-0 sm:ml-[10px] p-2"> 
                    <!--<font-awesome-icon :icon="['fas', 'pen-to-square']" alt="Aggiorna perizia" title="Aggiorna perizia" class="text-[#f8f9fa] text-xl cursor-pointer" @click="openEditPerizia(idxI, 'vcom')" />-->
                    <font-awesome-icon :icon="['fas', 'envelope']" alt="Invia perizia tramite email" title="Invia perizia tramite email" class="text-[#f8f9fa] text-xl cursor-pointer" @click="openSendEmailPerizia(idxI, 'vcom')" />
                    <font-awesome-icon :icon="['fas', 'trash']" alt="Elimina perizia" title="Elimina perizia" class="text-[#f8f9fa] text-xl cursor-pointer" @click="deletePerizia(idxI, ind, 'Vcom')" />
                    <font-awesome-icon :icon="['fas', 'download']" alt="Download Eurotax blu" title="Download Eurotax Blu" class="text-[#1598ce] text-xl cursor-pointer" @click="downloadPdf(ind, 'vcom', true)" />
                    <font-awesome-icon :icon="['fas', 'download']" alt="Download Eurotax blu" title="Download Eurotax Giallo" class="text-[#ffd21c] text-xl cursor-pointer" @click="downloadPdf(ind, 'vcom', false)" />
                </div>
            </div>
            <!--<div v-if="isEditOpen?.vcom[idxI]" class="my-[20px] px-[10px]">
                <input type="number" placeholder="Chilometri percorsi" v-model="km" class="mb-2" />
                <input type="number" placeholder="Valore attribuito dal concessionario (€)" v-model="importo" class="mb-2" />
                <div class="flex justify-end">
                    <button class="button py-[10px] px-[10px]" @click="updatePerizia(ind, 'vcom')">
                        <span>Aggiorna</span>
                    </button>
                </div>
            </div>--> 
            <div v-if="isEmailOpen?.vcom[idxI]" class="flex items-center my-[20px] px-[10px]">
                <input type="text" placeholder="Email" v-model="email" />
                <button class="button ml-[5px] py-[10px] px-[10px]" @click="sendEmail(ind, 'vcom')">
                    <span>Invia</span>
                </button>
            </div>  
        </div>
        <div class="flex justify-center items-center mt-[10px]">
            <button class="button py-[5px] px-[10px]" :class="{ 'disabled': vcomPage < 2 }" :disabled="vcomPage < 2" @click="firstPage('Vcom')">
                <font-awesome-icon :icon="['fas', 'angles-left']" class="text-xl" />
            </button>
            <button class="button ml-[5px] py-[5px] px-[10px]" :class="{ 'disabled': vcomPage < 2 }" :disabled="vcomPage < 2" @click="prevPage('Vcom')">
                <font-awesome-icon :icon="['fas', 'angle-left']" class="text-xl" />
            </button>
            <div class="mx-[20px] text-xl">{{ vcomPage }}</div>
            <button class="button mr-[5px] py-[5px] px-[10px]" :class="{ 'disabled': vcomPage >= Math.floor(vcomPaging?.totRecords / vcomPaging?.pageLength) + 1 }" 
            :disabled="vcomPage >= Math.floor(vcomPaging?.totRecords / vcomPaging?.pageLength) + 1" @click="nextPage('Vcom')">
                <font-awesome-icon :icon="['fas', 'angle-right']" class="text-xl" />
            </button>
            <button class="button py-[5px] px-[10px]" :class="{ 'disabled': vcomPage >= Math.floor(vcomPaging?.totRecords / vcomPaging?.pageLength) + 1 }" 
            :disabled="vcomPage >= Math.floor(vcomPaging?.totRecords / vcomPaging?.pageLength) + 1" @click="lastPage('Vcom')">
                <font-awesome-icon :icon="['fas', 'angles-right']" class="text-xl" />
            </button>
        </div>
    </div>
</template>

<script>
import { mainStore } from '../../store/main';
import axios from 'axios';

export default {
    name: 'ArchivioView',
    components: {},

    data() {
        return {
            mainStore,
            token: null,
            isArchivedShowed: false,
            perizieAuto: [],
            perizieMoto: [],
            perizieVcom: [],
            perizieAutoFiltered: [],
            perizieMotoFiltered: [],
            perizieVcomFiltered: [],
            isAutoOpen: true,
            isMotoOpen: true,
            isVcomOpen: true,
            mese: "",
            anno: "",
            months: [],
            years: [],
            autoPage: 1,
            autoPaging: {},
            motoPage: 1,
            motoPaging: {},
            vcomPage: 1,
            vcomPaging: {},
            isEditOpen: {
                auto: [],
                moto: [],
                vcom: []
            },
            isEmailOpen: {
                auto: [],
                moto: [],
                vcom: []
            },
            email: null,
            km: null,
            importo: null
        }
    },

    async created() {        
        if(!this.mainStore.abbonato?.adm) {
            this.$notify({
                title: "Errore",
                text: "Permessi non validi (adm mancante)",
                type: "error",
            });
            return;
        }

        const loader = this.$loading.show();

        await this.getPerizie(false);
        
        loader.hide();
    },

    methods: {
        openSendEmailPerizia(index, type) {
            this.isEmailOpen[type] = this.isEmailOpen[type].map((item, idx) => {
                if(index == idx) {
                    if(item) {
                        return false;
                    } else {
                        return true;
                    }
                }
                return false;
            })

            this.isEditOpen[type][index] = false;
        },
        async sendEmail(data, type) {
            if(!this.email) {
                this.$notify({
                    title: "Attenzione",
                    text: "Email mancante",
                    type: "warn",
                });
                return;
            }

            const loader = this.$loading.show();
            
            try {
                await axios.post(`${process.env.VUE_APP_HOST}/${process.env.VUE_APP_VERSION}/admonline/perizia/${type}/mail/${data?.id}`, {
                    blu: true,
                    giallo: true,
                    nota: false,
                    sezioni: {},
                    tipo: "QUOTAZIONE",
                    to: this.email
                })

                this.$notify({
                    title: "Email inviata con successo",
                    type: "success",
                });
            } catch(error) {
                console.log("e", error);                
                this.$notify({
                    title: "Errore nell'invio dell'email",
                    text: error?.response?.data?.message ? error.response.data.message : error?.response?.statusText,
                    type: "error",
                });
            }

            loader.hide();
        },
        openEditPerizia(index, type) {
            this.isEditOpen[type] = this.isEditOpen[type].map((item, idx) => {
                if(index == idx) {
                    if(item) {
                        return false;
                    } else {
                        return true;
                    }
                }
                return false;
            })

            this.isEmailOpen[type][index] = false;
        },
        /*async updatePerizia(data, type) {
            if(this.km == null || this.km < 0) {
                this.$notify({
                    title: "Attenzione",
                    text: "Chilometri percorsi errati o mancanti",
                    type: "warn",
                });
                return;
            }

            if(this.importo == null || this.importo < 0) {
                this.$notify({
                    title: "Attenzione",
                    text: "Valore attribuito dal concessionario errato o mancante",
                    type: "warn",
                });
                return;
            }

            const loader = this.$loading.show();
            try {                
                await axios.put(`${process.env.VUE_APP_HOST}/${process.env.VUE_APP_VERSION}/admonline/perizia/${type}/${data?.id}/prezzo_raccomandato_km`, {
                    importo: this.importo,
                    km: this.km
                }, { headers: { "Content-Type": "application/json" }});

                this.km = null;
                this.importo = null;
            
                this.$notify({
                    title: "Perizia aggiornata con successo",
                    type: "success",
                });            
            } catch(error) {
                console.log("e", error);
                this.$notify({
                    title: "Errore nell'aggiornamento della perizia",
                    text: error?.response?.data?.message ? error.response.data.message : error?.response?.statusText,
                    type: "error",
                });
            }

            loader.hide();
        },*/
        async downloadPdf(data, type, isBlue) {
            const loader = this.$loading.show();

            try {                
                const response = await axios.post(`${process.env.VUE_APP_HOST}/${process.env.VUE_APP_VERSION}/admonline/perizia/${type?.toLowerCase()}/pdf/quotazione/${isBlue}/${data?.id}`, {
                    "all": true,
                    "perizia": true,
                    "periziaGiallo": true,
                    "datiCliente": true,
                    "veicolo": true,
                    "datiTecnici": true,
                    "immagini": true,
                    "firma": true,
                    "danni": true,
                    "statoAttualeCarrozzeria": true,
                    "dataEmissione": true,
                    "venditore": true,
                    "dataValidita": true,
                    "codiceEurotax": true,
                    "statoVeicolo": true,
                    "optional": true,
                    "costiRipristino": true,
                    "lavoriMeccanica": true,
                    "lavoriCarrozzeria": true,
                    "speseVarie": true,
                    "correzioneZonale": true,
                    "correzioneAziendale": true,
                    "valutazioneDettaglio": true,
                    "valutazioneDettaglioGiallo": true,
                    "valutazioneBlu": true,
                    "valutazioneGiallo": true,
                    "valutazioneConcessionario": true,
                    "valutazioneIntesa": true,
                    "nota": true,
                    "prezzoListino": true,
                    "prezzoListinoGiallo": true,
                    "valutazioneBaseBlu": true,
                    "valutazioneBaseGiallo": true,
                    "lavoriTotaleOptionals": true,
                    "lavoriTotaleOptionalsGiallo": true,
                    "correzioneChilometri": true,
                    "correzioneChilometriGiallo": true,
                    "correzioneStatoMedio": true,
                    "correzioneStatoMedioGiallo": true,
                    "lavoriMeccanicaValore": true,
                    "lavoriCarrozzeriaValore": true,
                    "dannoPresunto": true,
                    "speseTotale": true,
                    "correzioneZonaleValore": true,
                    "correzioneAziendaleValore": true
                }, { headers: { "Content-Type": "application/json" },  responseType: 'blob'});
                
                const file = new Blob([response.data], { type: 'application/pdf' });
                const fileURL = URL.createObjectURL(file);
                const a = document.createElement('a');
                a.download = `Quotazione-${isBlue ? 'compera' : 'vendita'}-${data?.id}.pdf`;
                a.href = fileURL;
                a.addEventListener('click', () => {
                    setTimeout(() => URL.revokeObjectURL(a.href), 300);
                });
                a.click();
            } catch(error) {
                console.log("e", error);
                this.$notify({
                    title: "Errore nel download della valutazione Eurotax blu",
                    text: error?.response?.data?.message ? error.response.data.message : error?.response?.statusText,
                    type: "error",
                });
            }

            loader.hide();
        },
        async deletePerizia(index, data, type) {
            const loader = this.$loading.show();

            this.isEditOpen[type?.toLowerCase()] = this.isEditOpen[type?.toLowerCase()].map(item => {
                item = false;
                return item;
            });
            this.isEmailOpen[type?.toLowerCase()][index] = false;

            try {                
                await axios.delete(`${process.env.VUE_APP_HOST}/${process.env.VUE_APP_VERSION}/admonline/perizia/${type?.toLowerCase()}/${data?.id}`);
                await this[`getPerizia${type}`]();

                this.$notify({
                    title: "Perizia rimossa con successo",
                    type: "success",
                });
            } catch(error) {
                console.log("e", error);
                this.$notify({
                    title: "Errore nella rimozione della perizia",
                    text: error?.response?.data?.message ? error.response.data.message : error?.response?.statusText,
                    type: "error",
                });
            }

            loader.hide();
        },
        async firstPage(type) {
            if(this[`${type.toLowerCase()}Page`] < 2) {
                return;
            }
            
            const loader = this.$loading.show();

            this[`${type.toLowerCase()}Page`] = 1;
            await this[`getPerizia${type}`]();
            document.getElementById(type).scrollIntoView({behavior: 'smooth'});

            loader.hide();
        },
        async prevPage(type) {
            if(this[`${type.toLowerCase()}Page`] < 2) {
                return;
            }
            
            const loader = this.$loading.show();

            this[`${type.toLowerCase()}Page`]--;
            await this[`getPerizia${type}`]();
            document.getElementById(type).scrollIntoView({behavior: 'smooth'});

            loader.hide();
        },
        async nextPage(type) {
            if(this[`${type.toLowerCase()}Page`] > (this[`${type.toLowerCase()}Paging`]?.pageNumber * this[`${type.toLowerCase()}Paging`]?.pageLength) - 1) {
                return;
            }
            
            const loader = this.$loading.show();

            this[`${type.toLowerCase()}Page`]++;
            await this[`getPerizia${type}`]();
            document.getElementById(type).scrollIntoView({behavior: 'smooth'});

            loader.hide();
        },
        async lastPage(type) {
            if(this[`${type.toLowerCase()}Page`] >= Math.floor(this[`${type.toLowerCase()}Paging`]?.totRecords / this[`${type.toLowerCase()}Paging`]?.pageLength) + 1) {
                return;
            }
            
            const loader = this.$loading.show();

            let numPage = this[`${type.toLowerCase()}Page`] = Math.floor(this[`${type.toLowerCase()}Paging`]?.totRecords / this[`${type.toLowerCase()}Paging`]?.pageLength);
            if(this[`${type.toLowerCase()}Paging`]?.totRecords % this[`${type.toLowerCase()}Paging`]?.pageLength == 0) {
                this[`${type.toLowerCase()}Page`] = numPage;
            } else {
                this[`${type.toLowerCase()}Page`] = numPage + 1;
            }

            await this[`getPerizia${type}`]();
            document.getElementById(type).scrollIntoView({behavior: 'smooth'});

            loader.hide();
        },
        async filterSurveys() {
            if(!this.mese && this.anno) {
                this.$notify({
                    title: "Attenzione",
                    text: "Mese mancante",
                    type: "warn",
                });
                return false;
            }

            if(!this.anno && this.mese) {
                this.$notify({
                    title: "Attenzione",
                    text: "Anno mancante",
                    type: "warn",
                });
                return false;
            }         

            const loader = this.$loading.show();

            if(!this.mese && !this.anno) {
                this.perizieAutoFiltered = [ ...this.perizieAuto ];
                this.perizieMotoFiltered = [ ...this.perizieMoto ];
                this.perizieVcomFiltered = [ ...this.perizieVcom ];
            } else {
                await this.getPeriziaAuto();
                await this.getPeriziaMoto();
                await this.getPeriziaVcom();
            }

            loader.hide();
        },
        async getPeriziaAuto() {
            try {
                let data = null;
                if(this.mese && this.anno) {
                    data = `${this.anno}-${this.mese}-01`;
                }

                const responseAuto = await axios.post(`${process.env.VUE_APP_HOST}/${process.env.VUE_APP_VERSION}/admonline/perizia/auto/search`, {
                    page: {
                        "totRecords": 0,
                        "pageNumber": this.autoPage,
                        "pageLength": 10
                    },
                    dataInizio: data
                })

                if(responseAuto.data?.perizie) {
                    this.autoPaging = { ...responseAuto.data?.paging };
                    if(this.autoPaging?.totRecords % this.autoPaging?.pageLength == 0) {
                        this.autoPaging.totPages = Math.floor(this.autoPaging?.totRecords / this.autoPaging?.pageLength);
                    } else {
                        this.autoPaging.totPages = Math.floor(this.autoPaging?.totRecords / this.autoPaging?.pageLength) + 1;
                    }
                    this.perizieAuto = [ ...responseAuto.data?.perizie ];
                }
                
                this.perizieAutoFiltered = [ ...this.perizieAuto ];
            } catch(error) {
                console.log("e", error);
                this.$notify({
                    title: "Errore perizie auto",
                    text: error?.response?.data?.message ? error.response.data.message : error?.response?.statusText,
                    type: "error",
                });
            }
        },
        async getPeriziaMoto() {
            try {
                let data = null;
                if(this.mese && this.anno) {
                    data = `${this.anno}-${this.mese}-01`;
                }

                const responseMoto = await axios.post(`${process.env.VUE_APP_HOST}/${process.env.VUE_APP_VERSION}/admonline/perizia/moto/search`, {
                    page: {
                        "totRecords": 0,
                        "pageNumber": this.motoPage,
                        "pageLength": 10
                    },
                    dataInizio: data
                })

                if(responseMoto.data?.perizie) {
                    this.motoPaging = { ...responseMoto.data?.paging };
                    if(this.motoPaging?.totRecords % this.motoPaging?.pageLength == 0) {
                        this.motoPaging.totPages = Math.floor(this.motoPaging?.totRecords / this.motoPaging?.pageLength);
                    } else {
                        this.motoPaging.totPages = Math.floor(this.motoPaging?.totRecords / this.motoPaging?.pageLength) + 1;
                    }
                    this.perizieMoto = [ ...responseMoto.data.perizie ];
                }
                
                this.perizieMotoFiltered = [ ...this.perizieMoto ];
            } catch(error) {
                console.log("e", error);
                this.$notify({
                    title: "Errore perizie moto",
                    text: error?.response?.data?.message ? error.response.data.message : error?.response?.statusText,
                    type: "error",
                });
            }
        },
        async getPeriziaVcom() {
            try {
                let data = null;
                if(this.mese && this.anno) {
                    data = `${this.anno}-${this.mese}-01`;
                }

                const responseAuto = await axios.post(`${process.env.VUE_APP_HOST}/${process.env.VUE_APP_VERSION}/admonline/perizia/vcom/search`, {
                    page: {
                        "totRecords": 0,
                        "pageNumber": this.vcomPage,
                        "pageLength": 10
                    },
                    dataInizio: data
                })

                if(responseAuto.data?.perizie) {
                    this.vcomPaging = { ...responseAuto.data?.paging };
                    if(this.vcomPaging?.totRecords % this.vcomPaging?.pageLength == 0) {
                        this.vcomPaging.totPages = Math.floor(this.vcomPaging?.totRecords / this.vcomPaging?.pageLength);
                    } else {
                        this.vcomPaging.totPages = Math.floor(this.vcomPaging?.totRecords / this.vcomPaging?.pageLength) + 1;
                    }
                    this.perizieVcom = [ ...responseAuto.data.perizie ];
                }                
                
                this.perizieVcomFiltered = [ ...this.perizieVcom ];
            } catch(error) {
                console.log("e", error);
                this.$notify({
                    title: "Errore perizie commerciali",
                    text: error?.response?.data?.message ? error.response.data.message : error?.response?.statusText,
                    type: "error",
                });
            }
        },
        async getPerizie() {
            await this.getPeriziaAuto();
            this.perizieAutoFiltered.forEach((item, index) => {
                this.isEmailOpen.auto[index] = false;
                this.isEditOpen.auto[index] = false;
            })
            
            await this.getPeriziaMoto();
            this.perizieMotoFiltered.forEach((item, index) => {
                this.isEmailOpen.moto[index] = false;
                this.isEditOpen.moto[index] = false;
            })

            await this.getPeriziaVcom();
            this.perizieVcomFiltered.forEach((item, index) => {
                this.isEmailOpen.vcom[index] = false;
                this.isEditOpen.vcom[index] = false;
            })

            for(let i = 1; i < 13; i++) {
                if(i < 10) {
                    this.months.push("0" + i);
                } else {
                    this.months.push(i);
                }
            }
            for(let i = 2024; i > 2011; i--) {
                this.years.push(i);
            }
        },
    },
}
</script>

<style scoped>
</style>